import { createSlice } from '@reduxjs/toolkit';
import SimpleReactValidator from 'simple-react-validator';
import { QUOTING, QUOTED, ERROR } from 'shared/data/quoteSteps';

import defaultState from 'selective_solder_fixtures/data/defaultState';
import { columnSelected, rowSelected } from 'selective_solder_fixtures/data/parameters';
import { doQuote, addToCart } from 'selective_solder_fixtures/store/thunks';

export const validator = new SimpleReactValidator();

const ssfSlice = createSlice({
  name: 'ssf',
  initialState: defaultState,
  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload;
      state.parameters[name] = value;
      state.parameters.row_selected = rowSelected(state.parameters);
      state.parameters.column_selected = columnSelected(state.parameters);
    },
    updateQuantity(state, action) {
      state.quantity = action.payload;
    },
    updateValidatorFlag(state) {
      state.validatorFlag = !state.validatorFlag;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doQuote.pending, (state) => {
        state.quoteStep = QUOTING;
      })
      .addCase(doQuote.fulfilled, (state, action) => {
        const quote = action.payload;
        state.quoteStep = QUOTED;

        state.quote.line_items = quote.line_items;
        state.quote.number = quote.number;
        state.quote.variant_id = quote.variant_id;
        state.quote.product_name = quote.product_name;

        state.parameters.product_quote_number = quote.number;
      })
      .addCase(doQuote.rejected, (state) => {
        state.quoteStep = ERROR;
      })
      .addCase(addToCart.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(addToCart.rejected, (state) => {
        state.addingToCart = false;
      });
  },
});

export const {
  changeParameter,
  updateQuantity,
  updateValidatorFlag,
} = ssfSlice.actions;

export default ssfSlice.reducer;
